import { Component, OnInit, Input } from '@angular/core'
import { InstrumentAndPlanHelper } from '../instrument-and-plan-helper'
import { StripTagsPipe } from '../../pipes/striptags.pipe'
import { CdkTableModule } from '@angular/cdk/table'
import { CourtDocumentsComponent } from '../court-documents/court-documents'
import { PlanTreatmentsClassifiedComponent } from '../plan-treatment-classified/plan-treatment-classified'
import { PlanTreatmentsUnclassifiedComponent } from '../plan-treatment-unclassified/plan-treatment-unclassified'
import { NgTemplateOutlet, CurrencyPipe, DatePipe } from '@angular/common'
import { IconNamesEnum, NgxBootstrapIconsModule } from 'ngx-bootstrap-icons'
import { Dictionary } from '../filtering-search-component-base/filtering-search-types'
import { expandCollapse, openClose } from '../../animations/open-close-animations'

@Component({
    animations: [
        openClose,
        expandCollapse,
    ],
    selector: 'app-plan-view',
    templateUrl: './plan-view.component.html',
    styleUrls: ['./plan-view.component.scss'],
    imports: [
        NgTemplateOutlet,
        PlanTreatmentsUnclassifiedComponent,
        PlanTreatmentsClassifiedComponent,
        CourtDocumentsComponent,
        CdkTableModule,
        CurrencyPipe,
        StripTagsPipe,
        DatePipe,
        NgxBootstrapIconsModule
    ]
})
export class PlanViewComponent extends InstrumentAndPlanHelper  {
  @Input() set article(article: any) {
    this.plan = article.extras
  }

  @Input() plan : any = {}
  @Input() situationID : any = {}
  @Input() showMatches: boolean = false

  public isExpanded: Dictionary<boolean> = {}

  columnClasses() {
    if (Object.keys(this.plan).length == 1) {
      return "col my-2"
    } else {
      return "col-md-6 my-2"
    }
  }

}
